import Vue from "vue";
import Vuetify from "vuetify";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/dist/vuetify.min.css";
import ru from "vuetify/lib/locale/ru";

Vue.use(Vuetify);

const opts = {
  icons: {
    defaultSet: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#23919e",
      },
    },
  },
  lang: {
    locales: { ru },
    current: "ru",
  },
};

export default new Vuetify(opts);
